module.exports = __webpack_public_path__ + "images/6aba07a6d5e2eb1377561d243ad41ef1.png";